/**
 * Window of page indices the sheet page bar renders, centred on the current
 * sheet and clamped to the ends. Returns `[start, end)` — an exclusive end,
 * slice-style. Pages outside the window collapse into an ellipsis, with the
 * first and last always rendered separately so they stay one click away.
 */
export function pageWindow(currentIndex: number, total: number, maxVisible: number): [number, number] {
  if (total <= maxVisible) return [0, total]
  // Past the early return `start` is already capped at `total - maxVisible`,
  // so `start + maxVisible` can never exceed `total` — no clamp needed here.
  const start = Math.min(
    Math.max(0, currentIndex - Math.floor(maxVisible / 2)),
    total - maxVisible
  )
  return [start, start + maxVisible]
}
